import { Component, OnInit } from '@angular/core';
import { CentralService} from '../servicios/central.service';
import {faSignInAlt, faKey, faEuroSign, faTractor, faMoneyBill, faFileInvoice, 
        faUndo, faPrint, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import {AvisosComponent} from '../avisos/avisos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Router } from '@angular/router';

@Component({
  selector: 'app-fichacapimp',
  templateUrl: './fichacapimp.component.html',
  styleUrls: ['./fichacapimp.component.css']
})
export class FichacapimpComponent implements OnInit {

  datosTabla: any = [{}];

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoPrn = faPrint;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [this.icoKey, this.icoEur, this.icoTra, this.icoMny, this.icoInv, this.icoFac];

  resul: boolean;

  modoLis = 0;


  constructor(private srvCentral: CentralService, private modalService: NgbModal, private router: Router  ) { }
  
  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== '') {
       const k = this.srvCentral.listaMnu.length;
       this.menu = [];
       for ( let i = 0; i < k; i++)  {
           this.menu.push(
             { nombre: this.srvCentral.listaMnu[i].nombre,
               ruta:  this.srvCentral.listaMnu[i].ruta,
               icono: this.iconos[this.srvCentral.listaMnu[i].ico]
           } );

       }
    }

    this.modoLis = this.srvCentral.FicModoLis;
    this.cargaDatos();

  }

  cargaDatos() {
    this.resul = true;
    this.datosTabla = [];
    this.srvCentral.fichaCapital(this.modoLis, 0)
        .subscribe(datos => {
          if (datos[0].cpFecha === '?') {
            this.resul = false;
            const modalRef = this.modalService.open(AvisosComponent);
            modalRef.componentInstance.datAviso = {tit: 'ERROR SERVIDOR',
                                                   tex: datos[0].cpConce,
                                                   tip: 2,
                                                   btcan: '',
                                                   btno: '',
                                                   btsi: 'Aceptar'};
            modalRef.result.then((result) => {
            });

          } else {
               this.resul = false;
               this.datosTabla = [];
               for (const regis of datos) {
                    const tx = this.srvCentral.saca(regis.cpConce);
                    regis.cpConce = tx;
                    this.datosTabla.push(regis);
               }

          }
    });

  }

 volver(): void {
  this.router.navigate(['/fichacap']);
 }


}
